export const REMOVE_PRODUCTS_FROM_WISHLIST = /* GraphQL */ `
    mutation removeProductsFromWishlist(
        $wishlistId: ID!
        $wishlistItemsIds: [ID!]!
    ) {
        removeProductsFromWishlist(
            wishlistId: $wishlistId
            wishlistItemsIds: $wishlistItemsIds
        ) {
            wishlist {
                id
            }
            user_errors {
                code
                message
            }
        }
    }
`
